import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import SingleFieldForm from '~/components/molecules/SingleFieldForm.vue';
import { fetchCustomizable } from '~/services/customizable';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'CustomizableForm',
  components: {
    SingleFieldForm
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      value: '',
      showError: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    formProps() {
      return {
        title: this.payload.primary.title[0] || {},
        paragraph: this.payload.primary.paragraph || [],
        inputLabel: this.payload.primary.input_label || '',
        errorMessage: this.payload.primary.error_message,
        buttonText: this.payload.primary.button_text || ''
      };
    },

    formattedImage() {
      return "".concat(formatPrismicImage(this.payload.primary.image.url, ['w_375']), " 375w, ").concat(formatPrismicImage(this.payload.primary.image.url, ['w_375', 'dpr_1.6']), " 600w, ").concat(formatPrismicImage(this.payload.primary.image.url, ['w_1000']), " 1000w") || EMPTY_PIXEL;
    },

    formattedBgImage() {
      return formatPrismicImage(this.payload.primary.background_image.url) || '';
    },

    trackingParams() {
      return {
        data: {
          event_category: this.payload.primary.button_event_category,
          event_action: this.payload.primary.button_event_action,
          event_label: this.payload.primary.button_event_label
        }
      };
    }

  }),
  methods: {
    onSubmit(value) {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (value === '') {
          _this.showError = true;
          return;
        }

        var {
          status
        } = yield fetchCustomizable(_this.$store, value);

        if (status) {
          _this.$root.$emit('generic-tracking', null, _this.trackingParams);

          _this.$store.app.context.redirect("/".concat(_this.locale.market, "/").concat(_this.locale.language, "/configurator/").concat(value));
        }

        _this.showError = !status;
      })();
    }

  }
};